// src/components/AvailabilityManagement.js - VERSION RICH UI
import React, { useState, useEffect } from 'react';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Marcellus&family=DM+Sans:wght@300;400;500;600&display=swap');

  .avail-wrap {
    font-family: 'DM Sans', sans-serif;
    color: #1a1a1a;
  }

  /* ── HEADER ── */
  .avail-header {
    background: linear-gradient(135deg, #065f46 0%, #047857 100%);
    border-radius: 14px;
    padding: 24px 28px;
    margin-bottom: 24px;
    position: relative;
    overflow: hidden;
  }
  .avail-header::after {
    content: 'م';
    position: absolute;
    right: 20px; bottom: -10px;
    font-size: 80px;
    color: rgba(255,255,255,0.05);
    font-family: 'Marcellus', serif;
    pointer-events: none;
  }
  .avail-header-title {
    font-family: 'Marcellus', serif;
    font-size: 20px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 6px;
  }
  .avail-header-sub {
    font-size: 13px;
    color: rgba(255,255,255,0.6);
  }
  .avail-header-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
  }
  .btn-add-dispo {
    padding: 10px 20px;
    background: rgba(255,255,255,0.15);
    border: 1.5px solid rgba(255,255,255,0.3);
    border-radius: 10px;
    color: #fff;
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    white-space: nowrap;
  }
  .btn-add-dispo:hover { background: rgba(255,255,255,0.25); }
  .btn-add-dispo.cancel {
    background: rgba(239,68,68,0.2);
    border-color: rgba(239,68,68,0.4);
  }

  /* ── TOAST ── */
  .avail-toast {
    padding: 12px 16px;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 500;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .avail-toast.success { background: #f0fdf4; border: 1px solid #bbf7d0; color: #166534; }
  .avail-toast.error   { background: #fef2f2; border: 1px solid #fecaca; color: #991b1b; }
  .avail-toast.warn    { background: #fffbeb; border: 1px solid #fde68a; color: #92400e; }

  /* ── FORM CARD ── */
  .avail-form-card {
    background: #fff;
    border: 1.5px solid #e8e2d9;
    border-radius: 14px;
    padding: 24px;
    margin-bottom: 24px;
    animation: slideDown 0.2s ease-out;
  }
  @keyframes slideDown {
    from { opacity: 0; transform: translateY(-8px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  .form-card-title {
    font-family: 'Marcellus', serif;
    font-size: 16px;
    font-weight: 700;
    color: #065f46;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .form-row {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr auto;
    gap: 14px;
    align-items: end;
  }
  .form-field {}
  .form-field label {
    display: block;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.07em;
    color: #999;
    margin-bottom: 8px;
  }
  .form-select {
    width: 100%;
    padding: 10px 12px;
    border: 1.5px solid #e0d9ce;
    border-radius: 10px;
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    color: #1a1a1a;
    background: #faf9f7;
    outline: none;
    cursor: pointer;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23999'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 12px center;
    padding-right: 30px;
    transition: border-color 0.2s;
  }
  .form-select:focus { border-color: #047857; }
  .duration-badge {
    background: #d1fae5;
    color: #065f46;
    padding: 6px 12px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 4px;
  }
  .btn-save-dispo {
    width: 100%;
    padding: 11px 16px;
    background: linear-gradient(135deg, #065f46 0%, #047857 100%);
    color: #fff;
    border: none;
    border-radius: 10px;
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 3px 10px rgba(6,95,70,0.25);
  }
  .btn-save-dispo:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 6px 16px rgba(6,95,70,0.3); }
  .btn-save-dispo:disabled { opacity: 0.6; cursor: not-allowed; transform: none; box-shadow: none; }

  /* ── VUE TOGGLE ── */
  .view-toggle {
    display: flex;
    gap: 8px;
    margin-bottom: 20px;
  }
  .view-btn {
    padding: 8px 16px;
    border: 1.5px solid #e0d9ce;
    border-radius: 8px;
    background: #faf9f7;
    font-family: 'DM Sans', sans-serif;
    font-size: 12px;
    font-weight: 600;
    color: #666;
    cursor: pointer;
    transition: all 0.15s;
  }
  .view-btn.active { background: #065f46; border-color: #065f46; color: #fff; }

  /* ── VUE CALENDRIER ── */
  .calendar-grid {
    display: grid;
    grid-template-columns: 60px repeat(7, 1fr);
    border: 1px solid #e8e2d9;
    border-radius: 14px;
    overflow: hidden;
    background: #fff;
    margin-bottom: 24px;
  }
  .cal-header-cell {
    padding: 12px 8px;
    text-align: center;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    border-bottom: 2px solid #e8e2d9;
  }
  .cal-header-cell.jour-header {
    background: #f0fdf4;
    color: #065f46;
  }
  .cal-header-cell.time-col {
    background: #f7f4ef;
    color: #aaa;
  }
  .cal-time-cell {
    padding: 0 8px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 10px;
    color: #bbb;
    font-weight: 600;
    border-right: 1px solid #f0ebe2;
    background: #faf9f7;
  }
  .cal-slot {
    height: 48px;
    border-right: 1px solid #f0ebe2;
    border-bottom: 1px solid #f7f4ef;
    position: relative;
    cursor: pointer;
    transition: background 0.15s;
  }
  .cal-slot:last-child { border-right: none; }
  .cal-slot:hover { background: #f0fdf4; }
  .cal-slot.has-dispo {
    background: linear-gradient(135deg, #d1fae5, #a7f3d0);
  }
  .cal-slot.has-dispo.inactive {
    background: #f3f4f6;
  }
  .cal-slot.has-dispo:hover { filter: brightness(0.95); }

  /* ── VUE LISTE ── */
  .jour-section {
    background: #fff;
    border: 1px solid #e8e2d9;
    border-radius: 12px;
    margin-bottom: 12px;
    overflow: hidden;
  }
  .jour-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 18px;
    background: #f7f4ef;
    border-bottom: 1px solid #e8e2d9;
  }
  .jour-name {
    font-family: 'Marcellus', serif;
    font-size: 15px;
    font-weight: 700;
    color: #1a1a1a;
  }
  .jour-count {
    font-size: 11px;
    color: #aaa;
    background: #e8e2d9;
    padding: 2px 8px;
    border-radius: 10px;
  }
  .jour-empty {
    padding: 14px 18px;
    font-size: 13px;
    color: #ccc;
    font-style: italic;
  }
  .dispo-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 18px;
    border-bottom: 1px solid #f7f4ef;
    gap: 12px;
  }
  .dispo-row:last-child { border-bottom: none; }
  .dispo-time {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 700;
    color: #1a1a1a;
    min-width: 120px;
  }
  .dispo-duration {
    font-size: 11px;
    color: #065f46;
    background: #d1fae5;
    padding: 3px 10px;
    border-radius: 6px;
    font-weight: 600;
  }
  .dispo-status {
    font-size: 11px;
    font-weight: 700;
    padding: 3px 10px;
    border-radius: 6px;
  }
  .dispo-status.active   { background: #d1fae5; color: #065f46; }
  .dispo-status.inactive { background: #f3f4f6; color: #9ca3af; }
  .dispo-actions { display: flex; gap: 6px; }
  .btn-toggle-dispo {
    padding: 5px 12px;
    border: none;
    border-radius: 7px;
    font-family: 'DM Sans', sans-serif;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s;
  }
  .btn-toggle-dispo.deactivate { background: #fef3c7; color: #92400e; }
  .btn-toggle-dispo.deactivate:hover { background: #fde68a; }
  .btn-toggle-dispo.activate { background: #d1fae5; color: #065f46; }
  .btn-toggle-dispo.activate:hover { background: #a7f3d0; }
  .btn-delete-dispo {
    padding: 5px 10px;
    border: none;
    border-radius: 7px;
    background: #fee2e2;
    color: #dc2626;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.15s;
  }
  .btn-delete-dispo:hover { background: #fecaca; }

  /* ── EMPTY ── */
  .avail-empty {
    text-align: center;
    padding: 48px 20px;
    background: #fff;
    border: 1px solid #e8e2d9;
    border-radius: 14px;
  }
  .avail-empty-icon { font-size: 40px; margin-bottom: 14px; opacity: 0.35; }
  .avail-empty h3 {
    font-family: 'Marcellus', serif;
    font-size: 18px;
    color: #065f46;
    margin-bottom: 8px;
  }
  .avail-empty p { font-size: 13px; color: #aaa; }

  /* ── LOADING ── */
  .avail-loading {
    text-align: center;
    padding: 40px;
    color: #999;
    font-size: 14px;
  }
  .spinner-ring {
    width: 36px; height: 36px;
    border: 3px solid #e0d9ce;
    border-top-color: #047857;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    margin: 0 auto 12px;
  }
  @keyframes spin { to { transform: rotate(360deg); } }

  @media (max-width: 640px) {
    .form-row { grid-template-columns: 1fr 1fr; }
    .calendar-grid { display: none; }
  }
`;

const JOURS = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];
const JOURS_SHORT = { lundi: 'Lun', mardi: 'Mar', mercredi: 'Mer', jeudi: 'Jeu', vendredi: 'Ven', samedi: 'Sam', dimanche: 'Dim' };
const HOURS_DISPLAY = [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22];

const generateTimeOptions = () => {
  const opts = [];
  for (let h = 0; h <= 23; h++)
    for (let m = 0; m < 60; m += 15)
      opts.push(`${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}`);
  return opts;
};

const calcDuration = (start, end) => {
  if (!start || !end) return '';
  const s = start.length === 5 ? start : start.substring(0,5);
  const e = end.length === 5 ? end : end.substring(0,5);
  const diff = (new Date(`2000-01-01T${e}:00`) - new Date(`2000-01-01T${s}:00`)) / 60000;
  if (diff <= 0) return '';
  return diff >= 60 ? `${Math.floor(diff/60)}h${diff%60 > 0 ? ` ${diff%60}min` : ''}` : `${diff}min`;
};

const timeOptions = generateTimeOptions();

export default function AvailabilityManagement({ profId, token }) {
  const [disponibilites, setDisponibilites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [showAddForm, setShowAddForm] = useState(false);
  const [view, setView] = useState('liste'); // 'liste' | 'calendrier'
  const [newAvail, setNewAvail] = useState({ jour: 'lundi', heure_debut: '09:00', heure_fin: '18:00', is_active: true });
  const [dragState, setDragState] = useState(null); // { jour, startHour, endHour }
  const [contextMenu, setContextMenu] = useState(null); // { x, y, dispo }

  const showMsg = (msg) => { setMessage(msg); setTimeout(() => setMessage(''), 4000); };
  const msgType = message.includes('✅') ? 'success' : message.includes('⚠️') ? 'warn' : 'error';

  useEffect(() => {
    if (token && profId) fetchDisponibilites();
    else { showMsg('⚠️ Informations professeur manquantes'); setLoading(false); }
  }, [token, profId]);

  const fetchDisponibilites = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/disponibilites?prof_id=${profId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) setDisponibilites(data.disponibilites || []);
      else showMsg('❌ Erreur lors du chargement');
    } catch { showMsg('❌ Erreur de connexion'); }
    finally { setLoading(false); }
  };

  const handleAdd = async () => {
    if (newAvail.heure_debut >= newAvail.heure_fin) { showMsg('❌ L\'heure de fin doit être après le début'); return; }
    setSaving(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/disponibilites`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(newAvail)
      });
      const data = await res.json();
      if (data.success) {
        setDisponibilites([...disponibilites, data.disponibilite]);
        setNewAvail({ jour: 'lundi', heure_debut: '09:00', heure_fin: '18:00', is_active: true });
        setShowAddForm(false);
        showMsg('✅ Disponibilité ajoutée');
      } else showMsg(`❌ ${data.error}`);
    } catch { showMsg('❌ Erreur lors de l\'ajout'); }
    finally { setSaving(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer cette disponibilité ?')) return;
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/disponibilites/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) { setDisponibilites(disponibilites.filter(d => d.id !== id)); showMsg('✅ Supprimée'); }
      else showMsg(`❌ ${data.error}`);
    } catch { showMsg('❌ Erreur lors de la suppression'); }
  };

  const handleToggle = async (id, current) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/disponibilites/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ is_active: !current })
      });
      const data = await res.json();
      if (data.success) {
        setDisponibilites(disponibilites.map(d => d.id === id ? { ...d, is_active: !current } : d));
        showMsg(`✅ ${!current ? 'Activée' : 'Désactivée'}`);
      } else showMsg(`❌ ${data.error}`);
    } catch { showMsg('❌ Erreur'); }
  };

  // Vérifie si un slot horaire est couvert par une dispo
  // Handlers calendrier interactif
  const handleCalSlotMouseDown = (jour, hour) => {
    if (isSlotCovered(jour, hour)) return; // clic sur existant géré par handleCalSlotClick
    setDragState({ jour, startHour: hour, endHour: hour + 1 });
  };

  const handleCalSlotMouseEnter = (jour, hour) => {
    if (!dragState || dragState.jour !== jour) return;
    setDragState(prev => ({ ...prev, endHour: hour + 1 }));
  };

  const handleCalSlotMouseUp = async () => {
    if (!dragState) return;
    const { jour, startHour, endHour } = dragState;
    setDragState(null);
    const debut = String(startHour).padStart(2,'0') + ':00';
    const fin = String(Math.max(startHour + 1, endHour)).padStart(2,'0') + ':00';
    setSaving(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/disponibilites`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ jour, heure_debut: debut, heure_fin: fin, is_active: true })
      });
      const data = await res.json();
      if (data.success) {
        setDisponibilites(prev => [...prev, data.disponibilite]);
        showMsg('✅ Créneau ajouté');
      } else showMsg(`❌ ${data.error}`);
    } catch { showMsg('❌ Erreur lors de l\'ajout'); }
    finally { setSaving(false); }
  };

  const handleCalSlotClick = (e, dispo) => {
    e.stopPropagation();
    setContextMenu({ x: e.clientX, y: e.clientY, dispo });
  };

  const closeContextMenu = () => setContextMenu(null);

  const isSlotInDrag = (jour, hour) => {
    if (!dragState || dragState.jour !== jour) return false;
    const min = Math.min(dragState.startHour, dragState.endHour - 1);
    const max = Math.max(dragState.startHour, dragState.endHour - 1);
    return hour >= min && hour <= max;
  };

  const toMin = (t) => {
    const parts = t ? t.substring(0,5).split(':') : ['0','0'];
    return parseInt(parts[0]) * 60 + parseInt(parts[1]);
  };

  const isSlotCovered = (jour, hour) => {
    const slotStart = hour * 60;
    const slotEnd = (hour + 1) * 60;
    return disponibilites.some(d => {
      if (d.jour !== jour) return false;
      const dStart = toMin(d.heure_debut);
      const dEnd = toMin(d.heure_fin);
      return slotStart >= dStart && slotEnd <= dEnd;
    });
  };

  const getSlotDispo = (jour, hour) => {
    const slotStart = hour * 60;
    const slotEnd = (hour + 1) * 60;
    return disponibilites.find(d => {
      if (d.jour !== jour) return false;
      const dStart = toMin(d.heure_debut);
      const dEnd = toMin(d.heure_fin);
      return slotStart >= dStart && slotEnd <= dEnd;
    });
  };

  if (loading) return (
    <div className="avail-wrap" onMouseUp={handleCalSlotMouseUp} onClick={closeContextMenu}>
      <style>{styles}</style>
      <div className="avail-loading">
        <div className="spinner-ring" />
        Chargement de vos disponibilités…
      </div>
    </div>
  );

  return (
    <div className="avail-wrap">
      <style>{styles}</style>

      {/* Header */}
      <div className="avail-header">
        <div className="avail-header-top">
          <div>
            <div className="avail-header-title">🗓️ Gestion des disponibilités</div>
            <div className="avail-header-sub">
              Définissez vos créneaux par tranches de 15 minutes · {disponibilites.filter(d => d.is_active).length} créneau{disponibilites.filter(d => d.is_active).length !== 1 ? 'x' : ''} actif{disponibilites.filter(d => d.is_active).length !== 1 ? 's' : ''}
            </div>
          </div>
          <button
            className={`btn-add-dispo ${showAddForm ? 'cancel' : ''}`}
            onClick={() => setShowAddForm(!showAddForm)}
          >
            {showAddForm ? '✕ Annuler' : '+ Ajouter un créneau'}
          </button>
        </div>
      </div>

      {/* Toast */}
      {message && <div className={`avail-toast ${msgType}`}>{message}</div>}

      {/* Formulaire */}
      {showAddForm && (
        <div className="avail-form-card">
          <div className="form-card-title">✦ Nouveau créneau</div>
          <div className="form-row">
            <div className="form-field">
              <label>Jour</label>
              <select className="form-select" value={newAvail.jour} onChange={e => setNewAvail({...newAvail, jour: e.target.value})}>
                {JOURS.map(j => <option key={j} value={j}>{j.charAt(0).toUpperCase() + j.slice(1)}</option>)}
              </select>
            </div>
            <div className="form-field">
              <label>Heure de début</label>
              <select className="form-select" value={newAvail.heure_debut} onChange={e => setNewAvail({...newAvail, heure_debut: e.target.value})}>
                {timeOptions.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div className="form-field">
              <label>Heure de fin</label>
              <select className="form-select" value={newAvail.heure_fin} onChange={e => setNewAvail({...newAvail, heure_fin: e.target.value})}>
                {timeOptions.filter(t => t > newAvail.heure_debut).map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div className="form-field">
              <label>Durée</label>
              <div className="duration-badge">{calcDuration(newAvail.heure_debut, newAvail.heure_fin) || '—'}</div>
              <button className="btn-save-dispo" onClick={handleAdd} disabled={saving}>
                {saving ? '⏳ Ajout…' : '✓ Ajouter'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Toggle vue */}
      {disponibilites.length > 0 && (
        <div className="view-toggle">
          <button className={`view-btn ${view === 'liste' ? 'active' : ''}`} onClick={() => setView('liste')}>
            ☰ Liste
          </button>
          <button className={`view-btn ${view === 'calendrier' ? 'active' : ''}`} onClick={() => setView('calendrier')}>
            📅 Calendrier
          </button>
        </div>
      )}

      {/* Contenu */}
      {disponibilites.length === 0 ? (
        <div className="avail-empty">
          <div className="avail-empty-icon">📅</div>
          <h3>Aucune disponibilité configurée</h3>
          <p>Ajoutez vos créneaux pour que les élèves puissent vous réserver.</p>
        </div>
      ) : view === 'calendrier' ? (
        // VUE CALENDRIER
        <div className="calendar-grid">
          {/* Header */}
          <div className="cal-header-cell time-col">Heure</div>
          {JOURS.map(j => (
            <div key={j} className="cal-header-cell jour-header">{JOURS_SHORT[j]}</div>
          ))}
          {/* Lignes horaires */}
          {HOURS_DISPLAY.map(hour => (
            <React.Fragment key={hour}>
              <div className="cal-time-cell">{String(hour).padStart(2,'0')}h</div>
              {JOURS.map(jour => {
                const covered = isSlotCovered(jour, hour);
                const dispo = getSlotDispo(jour, hour);
                return (
                  <div
                    key={jour}
                    className={`cal-slot ${covered ? 'has-dispo' : ''} ${covered && !dispo?.is_active ? 'inactive' : ''} ${isSlotInDrag(jour, hour) ? 'dragging' : ''}`}
                    title={covered ? `${dispo?.heure_debut} - ${dispo?.heure_fin}` : `Cliquer pour ajouter ${String(hour).padStart(2,'0')}h-${String(hour+1).padStart(2,'0')}h`}
                    onMouseDown={() => !covered && handleCalSlotMouseDown(jour, hour)}
                    onMouseEnter={() => handleCalSlotMouseEnter(jour, hour)}
                    onMouseUp={handleCalSlotMouseUp}
                    onClick={covered ? (e) => handleCalSlotClick(e, dispo) : undefined}
                    style={{ cursor: covered ? 'pointer' : 'crosshair' }}
                  />
                );
              })}
            </React.Fragment>
          ))}
        </div>
      ) : (
        // VUE LISTE
        <div>
          {JOURS.map(jour => {
            const dispos = disponibilites.filter(d => d.jour === jour);
            return (
              <div key={jour} className="jour-section">
                <div className="jour-header">
                  <span className="jour-name">{jour.charAt(0).toUpperCase() + jour.slice(1)}</span>
                  <span className="jour-count">{dispos.length} créneau{dispos.length !== 1 ? 'x' : ''}</span>
                </div>
                {dispos.length === 0 ? (
                  <div className="jour-empty">Aucun créneau</div>
                ) : (
                  dispos.map(d => (
                    <div key={d.id} className="dispo-row">
                      <span className="dispo-time">{d.heure_debut} → {d.heure_fin}</span>
                      <span className="dispo-duration">{calcDuration(d.heure_debut, d.heure_fin)}</span>
                      <span className={`dispo-status ${d.is_active ? 'active' : 'inactive'}`}>
                        {d.is_active ? '● Actif' : '○ Inactif'}
                      </span>
                      <div className="dispo-actions">
                        <button
                          className={`btn-toggle-dispo ${d.is_active ? 'deactivate' : 'activate'}`}
                          onClick={() => handleToggle(d.id, d.is_active)}
                        >
                          {d.is_active ? 'Désactiver' : 'Activer'}
                        </button>
                        <button className="btn-delete-dispo" onClick={() => handleDelete(d.id)}>✕</button>
                      </div>
                    </div>
                  ))
                )}
              </div>
            );
          })}
        </div>
      )}
      {/* Context menu créneau existant */}
      {contextMenu && (
        <div
          style={{
            position: 'fixed',
            top: contextMenu.y,
            left: contextMenu.x,
            background: '#fff',
            border: '1px solid #e2e8f0',
            borderRadius: 8,
            boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
            zIndex: 9999,
            minWidth: 180,
            overflow: 'hidden'
          }}
          onClick={e => e.stopPropagation()}
        >
          <div style={{ padding: '10px 14px', borderBottom: '1px solid #f1f5f9', fontSize: 12, color: '#64748b', fontWeight: 600 }}>
            {contextMenu.dispo?.jour} {contextMenu.dispo?.heure_debut?.substring(0,5)} → {contextMenu.dispo?.heure_fin?.substring(0,5)}
          </div>
          <button
            style={{ display: 'block', width: '100%', padding: '10px 14px', textAlign: 'left', background: 'none', border: 'none', cursor: 'pointer', fontSize: 13, color: '#374151' }}
            onClick={() => { handleToggle(contextMenu.dispo.id, contextMenu.dispo.is_active); closeContextMenu(); }}
          >
            {contextMenu.dispo?.is_active ? '⏸ Désactiver' : '▶ Activer'}
          </button>
          <button
            style={{ display: 'block', width: '100%', padding: '10px 14px', textAlign: 'left', background: 'none', border: 'none', cursor: 'pointer', fontSize: 13, color: '#ef4444' }}
            onClick={() => { handleDelete(contextMenu.dispo.id); closeContextMenu(); }}
          >
            🗑 Supprimer
          </button>
        </div>
      )}
    </div>
  );
}
